















import GlobalMixin from "@/mixins/global";
export default GlobalMixin.extend({
  components: {
    // Incluimos el layout que utilizará este módulo
    // Layout
  },
  data() {
    return {
      moduleName: "BREADCRUMB-NAV",
    };
  },
  computed: {
    items() {
      let route: any = this.$route;
      let rol = this.$store.getters["auth/rol"];
      if (typeof route.meta.breadcrumb === "function") {
        return this.$route.meta.breadcrumb.call(this, this.$route, rol);
      }
      return route.meta.breadcrumb;
    },
  },
});
